import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { acceptAgreement } from './accept-agreement';
import { logErrorFromClientSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function acceptCustomerAgreementAndPrivacyPolicy(
    request: {
        version: string;
        language: string;
        countryCode: string;
    },
    dependencies: DependenciesPayload,
): Promise<void> {
    try {
        return await acceptAgreement(
            'Customer Agreement and Privacy policy',
            { request },
            dependencies,
        );
    } catch (error: any) {
        logErrorFromClientSdk(error, dependencies);
        throw new Error('SYSTEM');
    }
}
